





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class IpFieldWidget extends Vue {
  // @Prop() public onChange!: any;
  @Prop({ type: String }) public ip!: string;
  @Prop({ type: String }) public port!: string;
  @Prop(Boolean) public placeholder!: boolean;
  @Prop(Boolean) public showPort!: boolean;
  @Prop([String, Boolean]) public theme!: boolean | string;

  public ipCopy = ['', '', '', ''];
  public portCopy: boolean | null = false;
  public valid: boolean = false;
  public active: boolean = false;

  public beforeMount() {
    // Copy the values over
    this.copyValue(this.ip, this.port);
  }

  @Watch('ip')
  /**
   * Watch the IP prop for changes and update internally
   */
  public onIpChanged(newIp) {
    this.copyValue(newIp, this.port);
  }

  @Watch('ip')
  /**
   * Watch the port for changes and update internally
   */
  public onPortChanged(newPort) {
    this.copyValue(this.ip, newPort);
  }

  /**
   * Placeholder with dummy IP
   */
  public placeholderPos(segment): any {

    // No placeholder
    if (!this.placeholder) {
      return '';
    }

    // Dummy IP placeholder
    switch (segment) {
      case 0:
        return '192';
      case 1:
        return '168';
      case 2:
        return '0';
      case 3:
        return '1';
    }

  }

  /**
   * On focus clear the current box
   */
  public ipFocus(index) {

    this.active = true;

    // Clear it
    // this.ipCopy[index] = '';

    // Update the change
    this.changed();

  }

  /**
   * Clear both inputs
   */
  public clearAll() {
    this.ipCopy = ['', '', '', ''];
    this.portCopy = false;
    this.valid = false;
  }

  /**
   * Clicked off the IP or port
   */
  public blur() {
    this.active = false;

  }

  /**
   * Focus on the port
   */
  public portFocus() {

    this.active = true;

    // Clear it
    this.portCopy = null;

    // Update the change
    this.changed();

  }

  /**
   * Paste in an IP (with or without a port)
   */
  public paste(event) {

    if (this.$refs!.ipSegment![0]) {
      // Focus on first el
      this.$refs!.ipSegment![0].focus();
    }

    // Get clipboard text
    const pasteText = event.clipboardData.getData('text/plain');

    // Check if we have a port or not
    const portPos = pasteText.indexOf(':');

    // If we have ports turned off, remove the port and only update the IP value
    if (!this.port) {

      console.warn('A IP address with a port has been entered but this module has no port attribute. Please enable it update the port.');

      this.clearAll();

      const ipAndPort = pasteText.split(':');
      this.copyValue(ipAndPort[0], false);

      // Blur off input
      this.$refs.ipSegment![0].blur();

      return;
    }

    // Based on if we have a port or not
    switch (portPos) {
      case -1:
        this.copyValue(pasteText, null);
        this.changed();

        // Blur off input
        this.$refs.ipSegment![0].blur();

        break;
      default:
        const ipAndPort = pasteText.split(':');
        this.copyValue(ipAndPort[0], ipAndPort[1]);
        this.changed();

        // Blur off input
        this.$refs.ipSegment![0].blur();

        break;
    }

  }

  /**
   * Port keydown event
   */
  public portKeydown() {

    const keyCode = (event as any).keyCode || (event as any).which;

    // Return or left on keypad
    if (keyCode === 8 || keyCode === 37) {

      // If there is nothing within the selected input go back to the last IP segment
      if (this.portCopy) {
        this.$refs.ipSegment![3].focus();
      }

    }

    setTimeout(this.changed);
  }

  /**
   * Run on keydown
   */
  public ipKeydown(event, index) {

    const keyCode = event.keyCode || event.which;

    // Return or left on keypad
    if (keyCode === 8 || keyCode === 37) {

      // If there is nothing within the selected input go the the one before it
      if (this.ipCopy[index].length === 0 && this.ipCopy[index - 1] !== undefined) {
        this.$refs.ipSegment![index - 1].focus();
      }

    } /*Semi-colon (jump to port number)*/ else if (keyCode === 186) {
      (this.$refs.portSegment as any).focus();
    }

    setTimeout(() => {

      // If its a 0 then always move to the next segment, if not work out if we need to move first
      if (this.ipCopy[index] === '0') {
        this.moveToNextIpSegment(index, false);
      } else {
        this.moveToNextIpSegment(index);
      }

      // Update the change
      this.changed();

    });
  }

  /**
   * Work out if we need to move to the next IP segment or not
   */
  public moveToNextIpSegment(index, ifOverThree = true) {

    /**
     * If there is 3 characters check if there is another segment, if there is focus on it.
     */
    if (ifOverThree) {
      if (this.ipCopy[index].length >= 3 && this.ipCopy[index + 1] !== undefined) {
        this.$refs.ipSegment![index + 1].focus();
      } else if (this.ipCopy[index].length >= 3 && this.ipCopy[index + 1] === undefined) {
        (this.$refs.portSegment as any).focus();
      }

    } else if (!ifOverThree) {
      if (this.ipCopy[index + 1] !== undefined) {
        this.$refs.ipSegment![index + 1].focus();
      } else if (this.ipCopy[index + 1] === undefined) {
        (this.$refs.portSegment as any).focus();
      }

    }

  }

  /**
   * Update the controller with changed IP and port addresses
   */
  public changed(ip = this.ipCopy, port = this.portCopy) {
    const ipLocal = this.arrayToIp(ip);
    this.$emit('on-change', ipLocal, port, this.validateIP(ip));
  }

  /**
   * Copy prop into local copy
   */
  public copyValue(ip, port) {
    if (ip) {
      this.ipToArray(ip);
    }

    // Update the port as long as its a number
    this.portCopy = port;

    // Update if its valid locally
    this.valid = this.validateIP(this.ipCopy);

    // Report right back with if its valid or not
    this.changed();

  }

  /**
   * Convert the IP address string to an array of values
   */
  public ipToArray(ip) {

    const segments: any[] = [];
    ip.split('.').map((segment: any) => {
      if (isNaN(segment) || segment < 0 || segment > 255) {
        segment = 255;
      }
      segments.push(segment);
    });

    // If something is not valid clear it all
    if (segments.length !== 4) {
      console.error('Not valid, so clearing ip', segments);
      this.clearAll();
    } else {
      this.ipCopy = segments;
    }

  }

  /**
   * Convert the array of IP segments back to a string
   */
  public arrayToIp(ipArray) {
    return ipArray.join('.');
  }

  /**
   * validates the IP address
   *
   * @returns Boolean
   */
  public validateIP(ip) {
    const ipCheck = this.arrayToIp(ip);
    return (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipCheck));
  }
}
